import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

function MyPurchasesButton() {
  return (
    <Button
      type="secondary"
      customClass="pricing-area__actions-button pricing-area__actions-left-button"
      size="large"
      href="/profile/purchases"
      aria-label="My purchases"
    >
      My purchases
    </Button>
  )
}

export default MyPurchasesButton
